import React, { useState, useEffect } from 'react'
import swal from 'sweetalert';
import axios from 'axios';
import $ from 'jquery';
import Moment from 'moment';
import jsPDF from 'jspdf';
import Select from 'react-select';
import html2pdf from 'html2pdf.js';
import Receipt from '../Receipt/Receipt';
import ReceiptUser from '../Receipt/ReceiptUser';
import Royal_logo from '../../Assets/images/Royal-logo.svg';
import Notice from '../../Assets/images/Roya-Resort-Notice.png'

export default function ByUser(props) {
    const [items, setitems] = useState({})
    const [payment, setpayment] = useState({ MethodId: "", BookingId: "", Payment: "", company_id: props.companyid });
    const [receviedamount, setreceviedamount] = useState({})
    const [bookingdetails, setbookingdetails] = useState({});
    const [addshift, setshift] = useState([])
    const [shiftvalue, setshiftvalue] = useState()
    const [mainimage, setmainimage] = useState([])
    const [isValid, setisValid] = useState(false);
    const [typevalue, settypevalue] = useState()
    const [stypevalue, setstypevalue] = useState()
    const [typevaluenew, settypevaluenew] = useState()
  
    useEffect(() => {
        fetchagentdata()
    }, [])
    const settypevalues = (e) => { }
        
    const [type, settype] = useState()

    async function fetchagentdata(unitid) {
        const Uniturl = process.env.REACT_APP_APIURL + "FramUnit/agent?companyid=" + props.companyid;
        let response = await axios.get(Uniturl);
        var data = [];
        response.data.map((u) => {

            data.push({ value: u.id, label: u.f_name });
        })
        settype(data);

    }


    async function populatedata(id) {
        debugger;
        if (id.length == 0) {
            setitems({});
            // setpayment({...payment, Payment: "" });
            setreceviedamount({});
            setisValid(false)
            $('.customer_payment').slideUp();
            setisValid(false);
            $('#btnprint').hide()
            return;

        }
        const url = process.env.REACT_APP_APIURL + "payment/Getdata?userid=" + id + "&companyid=" + props.companyid;
        await fetch(url).then(res => res.json()).then(result => {
            debugger;
            if (result.status == 404) {
                // debugger;
                setitems({});
                // setpayment({...payment, Payment: "0" });
                
                setisValid(false)
                $('.customer_payment').slideUp();
                $('#btnprint').hide();
            }
            else {

                $('.customer_payment').slideDown()
                setitems(result);
                setisValid(true);

                $('#btnprint').show()

            }

        }).catch((err) => {
            console.log(err);
        });
    }
    
    const refresh = () => {
        setitems({});
        setpayment({ MethodId: "", BookingId: "", Payment: "", company_id: props.companyid });
        setreceviedamount({});
        setisValid(false)
        $('.customer_payment').slideUp();
        $('#btnprint').hide()
        $('#log').hide()
    }
   
    const handleSubmit = async (e) => {
    //    e.preventDefault();
    //    const submitButton = e.target.querySelector('button[type="submit"]');
    //    submitButton.disabled = true;
    //    submitButton.innerHTML = '<section><span class="loader-5"> </span></section>';

    //    try {
    //        console.log(isValid);
    //        if (isValid) {
    //            var remainingamount =
    //                (!isNaN(items.amount) ? items.amount : 0) -
    //                (!isNaN(receviedamount.payment) ? receviedamount.payment : 0);
    //            if (items.option2 === "2") {
    //                if (remainingamount === payment.Payment) {
    //                    await savemethod(payment);
    //                } else {
    //                    alert("You have to pay the full remaining amount");
    //                }
    //            } else {
    //                if (payment.Payment > remainingamount) {
    //                    alert("Receiving amount is greater than the remaining amount");
    //                } else {
    //                    await savemethod(payment);
    //                }
    //            }
    //        } else {
    //            alert("Booking ID is not valid");
    //        }
    //    } catch (error) {
    //        console.log(error);
    //        alert("An error occurred while saving: " + error);
    //    } finally {
    //        submitButton.disabled = false;
    //        submitButton.innerHTML = "Submit";
    //    }
    };
    /* test fucntion */
    var specialElementHandlers = {
        '#editor': function (element, renderer) {
            return true;
        }
    };

    

    async function paymentdata(id) {
        const url = process.env.REACT_APP_APIURL + "payment/GetReceviedAmount?bookingid=" + id + "&companyid=" + props.companyid;
        await fetch(url).then(res => res.json()).then(result => {

            if (result.status == 404) {
                receviedamount.payment = 0
            }
            else {
                setreceviedamount(result);
            }

        }).catch((err) => {
            console.log(err);
        });
    }
   
    /* modal fadeout */
    const modelOut1 = (e) => {
        e.preventDefault();
        $("#myModal").modal('hide');
    };
    
   const modalshow1 = ()=>{
     $("#myModal").modal('show');
   }
    /* inline styling */
    const card = {
        marginBottom: '1.875rem',
        backgroundColor: '#fff',
        transition: 'all 0.5s ease-in-out',
        position: 'relative',
        border: '0rem solid transparent',
        borderRadius: '1.375rem',
        boxShadow: 'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px',
        height: 'calc(100% - 1.875rem)',
    }
    const card_body = {
        padding: '0.5rem 2rem 0rem',
        flex: '1 1 auto',
    }
    const card_header = {
        borderColor: '#ffffff',
        position: 'relative',
        background: '#1d3641',
        padding: '1.5rem 1.875rem 1.25rem',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        backgroundColor: '#002a73',
        borderRadius: '0 !important',
        backgroundColor: '#fff',
        paddingBottom: '0',
        flexDirection: 'column',
        alignItems: 'center',
        marginBottom: '1.2rem',
    }
    const card_logo = {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    }
    const img_logo = {
        width: '225px',
        height: '75px',

    }
    const re_heading = {
        marginTop: '0.5rem',
    }
    const d_grid = {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
    }
    const lineGrid = {
        disply: 'flex',
        marginBottom: '0.5rem',
    }
    const inLIne = {
        disply: 'flex',
        paddingRight: '0.6rem',
    }
    const pdRight = {
        paddingRight: '0.5rem',
    }
    const uLine = {
        fontWeight: '600',
        borderBottom: '1px solid gray',
        transform: 'translateY(-6px)',
        paddingLeft: '0.3rem',
        fontSize: '0.9rem',
    }
    const p_right = {
        paddingRight: '0.8rem',
    }
    const f_child = {
        paddingRight: '0.2rem',
        fontSize: '0.9rem',
    }
    const in_checkBox = {
        display: 'inline-flex',
        alignItems: 'center',
    }
    const in_label = {
        paddingRight: '0.2rem',
        margin: '0',
    }
    const in_checkbox = {
        height: '15px',
        width: '15px',
    }
    const center_text = {
        textAlign: 'center',
    }
    const fn_size = {
        fontSize: '0.8rem',
        marginBottom: '0',
    }
    const flx_main = {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        flexWrap: 'wrap',
        width: '100%',
    }
    const col_5 = {
        display: 'flex',
        flex: "0 0 50%",
        maxWidth: "50%",
    }
    const col_4 = {
        display: 'flex',
        flex: '0 0 40%',
        maxWidth: '40%',
    }
    const col_6 = {
        display: 'flex',
        flex: '0 0 60%',
        maxWidth: '60%',
    }
    const col_7 = {
        display: 'flex',
        flex: '0 0 70%',
        maxWidth: '70%',
    }
    const col_8 = {
        flex: '0 0 80%',
        maxWidth: '80%'
    }
    const col_3 = {
        display: 'flex',
        flex: '0 0 30%',
        maxWidth: '30%',
    }
    const col_33 = {
        display: 'flex',
        flex: '0 0 33%',
        maxWidth: '33%',
    }
    const col_2 = {
        display: 'flex',
        flex: '0 0 20%',
        maxWidth: '20%',
    }
    const col_1 = {
        display: 'flex',
        flex: '0 0 10%',
        maxWidth: '10%',
    }
    const col_9 = {
        display: 'flex',
        flex: '0 0 90%',
        maxWidth: '90%',
    }
    const col_10 = {
        display: 'flex',
        flex: "0 0 100%",
        maxWidth: '100%',
    }
    const col_65 = {
        flex: '0 0 65%',
        maxWidth: '65%',
    }
    const col_25 = {
        flex: '0 0 25%',
        maxWidth: '25%',
    }
    const m_b1 = {
        marginBottom: '1rem',
    }
    const d_flex = {
        display: 'flex',
    }
    const under_line = {
        textDecoration: 'underline',
    }
    const ul_list = {
        marginBottom: '0.4rem',
        listStyle: 'auto',
    }
    const ul_sty = {
        paddingLeft: '1.5rem'
    }
    const mr_top3 = {
        marginTop: '3rem',
    }
    const gatePass = (e) => {
        e.preventDefault();
        let printEleme = document.getElementById('gatePas');
        var opt = {
            padding:[0,0,3,0],
            filename:`Payment_Detail`,
            image: { type: 'jpeg', quality: 1 },
            html2canvas: {
                scale: 2,
                bottom: 20,
            },
            pagebreak: {  before: '.before' },
            jsPDF: {
                unit: 'mm',
                orientation: 'portrait'
            }
        };
        html2pdf().set(opt).from(printEleme).then(function () {
            $("#inner").css({ "font-size": "12px", "background-color": "#F5F5F5" });
        }).save();
    }
    return (
        <div className="row">
            <div className="col-12">
                <div className="card">
                    <div className="card-header">
                        <h3 className="me-auto mb-2 mt-5 text-center mx-auto">User Booking</h3>
                    </div>
                    <div className="card-body">
                        <div className="basic-form">
                            <form onSubmit={handleSubmit}>

                                <div className="row flex-column align-items-center">
                                    
                                    <div className="mb-3 col-11 col-md-6">
                                        <label htmlFor="booking_id" className="form-label">Users</label>
                                        <Select value={typevalue} options={type} onChange={function (e) { populatedata(e.value); setitems({ ...items, type: e.value }) }} />
                                    </div>
                                    </div>
                                
                                <div className="row mt-4 customer_payment" style={{ display: "none" }}>
                                    <div className="mt-3 float-right">
                                    <button onClick={modalshow1} className="btn btn-primary" id="btnprint" type="button" style={{ display: "none" }} >Print Detail</button>
                                    </div>
                                    <div id="customer_payment" className="row">
                                        <ReceiptUser
                                            userDetails={{
                                                name: items.name,
                                                email: items.email,
                                                count: items.rowcount,
                                            }}
                                            paymentDetails={{
                                                recpay: items.recPay,
                                               
                                                total: items.total
                                            }}
                                        />
                                    </div>
                                </div>


                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <div id="editor">
            </div>
            <div id="myModal" className="modal fade " tabIndex="-1">
                <div className="modal-dialog modal-lg">
                    <div className="modal-content" >
                       
                        {/* gat pass card */}
                        <div className='card' id="gatePas">
                            <div className='card-header d-flex flex-column' >
                                <div style={card_logo}>
                                    <img style={img_logo} src={Royal_logo} alt="Royal-Logo" />
                                </div>
                                <h3>Payment Receipt</h3>
                                <div className='download_button' id='repoPrint' data-html2canvas-ignore="true"><a onClick={gatePass} href="">Download</a><a onClick={modelOut1} href="">✕</a></div>
                            </div>
                            <div className='card-body'>
                                {/* important notes */}
                                <div id="customer_payment" className="row print_detail  html2pdf__page-break">
                                        <ReceiptUser
                                            userDetails={{
                                                name: items.name,
                                                email: items.email,
                                                count: items.rowcount,
                                            }}
                                            paymentDetails={{
                                                recpay: items.recPay,
                                                total: items.total
                                            }}
                                        />
                                    </div>
                                {/* footer signnature */}
                                <div className='my_updatepdf'>
                                    <img src={Notice} alt="notice_PDf" />
                                </div>
                            </div>
                        </div>
                        {/* gat pass card */}
                    </div>
                </div>
            </div>
        </div>


    )
}


